<template>
  <div class="app-contain">
    <div class="top_title">
      <img src="../../assets/satistics/img-title.png" alt="" class="top_title_img">
      <img src="../../assets/satistics/img-title-effect.png" alt="" class="top_title_effect">
      <div class="title_text">灵峰村数字乡村大数据平台</div>
      <div class="left_light"></div>
      <div class="right_light"></div>
    </div>

    <div class="center_pad">
      <div class="inner_left">
        <img src="../../assets/satistics/img-house-back.png" alt="" class="left_back">
        <div class="center_content">
          <!--          <img src="../../assets/satistics/img-1.jpg" alt="" class="info_img">-->
          <video :src="videoUrl" controls muted :autoplay="true" class="info_img"></video>
        </div>

      </div>
      <div class="inner_right">
        <div class="inner_content_line"
             @click="goPage(0)"
             style="background: linear-gradient(to right,rgba(26, 69, 206, 0.7),rgba(26, 69, 206, 0));border-image-source: linear-gradient(to right, rgba(67, 189, 255, 0.7) 0%, rgba(67, 189, 255, 0) 80%, rgba(67, 189, 255, 0) 100%);">
          <img src="../../assets/satistics/icon-enter1.png" alt="" class="inner_left_icon">
          <div class="inner_text">可视化大屏</div>
          <img src="../../assets/satistics/icon-enter-more.png" alt="" class="inner_right_icon">
        </div>
        <div class="inner_content_line"
             @click="goPage(1)"
             style="background: linear-gradient(to right,rgba(5, 21, 72, 0.7),rgba(5, 21, 72, 0));border-image-source: linear-gradient(to right, rgba(22, 72, 141, 0.7) 0%, rgba(22, 72, 141, 0) 80%, rgba(67, 189, 255, 0) 100%);">
          <img src="../../assets/satistics/icon-enter2.png" alt="" class="inner_left_icon">
          <div class="inner_text">后台管理</div>
          <img src="../../assets/satistics/icon-enter-more.png" alt="" class="inner_right_icon">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "guidepage",
    data() {
      return {
        videoUrl: process.env.NODE_ENV == 'development' ? 'https://lfczhxc.com/file/videos/lfc.mp4' : 'https://lfczhxc.com/file/videos/lfc.mp4',
        info: '灵峰村位于相城区北桥街道西北，北接常熟。西邻无锡。辖区面积6.9平方公里，常住人口约1.5万人，其中本地户籍6842人、外来务工人员8700人，企业301家。辖区内共有通信铁塔18座，广电网络1714户，宽带、5G网络、数字电视实现100%全覆盖。。先后获得“全国文明村”、“全国民主法治示范村”、“全国和谐社区建设示范社区”等荣誉称号。'
      }
    },
    created(){

      // 判断登录状态
      this.$http.get('api/tPlatformOne/getMemberTotal').then(res => {
        if (res.data.code == 200) {
          // this.peopleNum = res.data.data
        }
      })
    },
    methods: {
      goPage(key) {
        if (key == 0) {
          this.$router.push('/satistics')
        } else if (key == 1) {
          this.$router.push('/home')
        }
      }
    }
  }
</script>

<style scoped lang="less">
  .app-contain {
    position: relative;
    height: 100%;
    width: 100%;
    min-width: 1600px;
    min-height: 900px;
    background: url("../../assets/satistics/gif-index-back.gif");
    background-size: cover;

    .top_title {
      position: relative;
      width: 112%;
      left: 50%;
      transform: translate(-50%, -31%);

      .top_title_img {
        width: 100%;
      }

      .top_title_effect {
        position: absolute;
        left: 50%;
        top: 32%;
        transform: translate(-50%, 0);
      }

      .title_text {
        position: absolute;
        font-size: 44px;
        font-weight: 600;
        color: #FFFFFF;
        letter-spacing: 6px;
        text-shadow: 2px 3px 0px #0F298B;
        top: 44%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .left_light {
      position: absolute;
      left: 30%;
      top: 51%;
      width: 45px;
      height: 2px;
      background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 25%, rgba(255, 255, 255, 1) 75%, rgba(255, 255, 255, 0) 100%);
      animation: leftMove 3s linear 0s infinite;
      z-index: 100;
    }

    .right_light {
      position: absolute;
      right: 30%;
      top: 51%;
      width: 45px;
      height: 2px;
      background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 25%, rgba(255, 255, 255, 1) 75%, rgba(255, 255, 255, 0) 100%);
      animation: rightMove 3s linear 0s infinite;
      z-index: 100;
    }

    .center_pad {
      position: absolute;
      top: 57%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      flex-direction: column;
      align-content: center;
      align-items: center;

      .inner_left {
        position: relative;
        width: 1100px;
        height: 650px;

        .left_back {
          width: 100%;
          height: 100%;
        }

        .center_content {
          position: absolute;
          width: 80%;
          left: 50%;
          top: 54%;
          transform: translate(-50%, -50%);

          .info_img {
            width: 100%;
          }

          .card_text {
            background: rgba(0, 25, 61, 0.65);
            padding: 0.4rem 1rem;
            font-size: 14px;
            font-weight: 400;
            color: #D5E6FF;
            line-height: 20px;

            span {
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }


      }

      .inner_right {
        display: flex;
        .inner_content_line {
          display: flex;
          align-items: center;
          border: 1px solid;
          border-image-slice: 1;
          cursor: pointer;
          margin: 2.5rem 2rem;

          .inner_left_icon {
            width: 130px;
          }

          .inner_text {
            width: 12rem;
            color: white;
            font-size: 28px;
          }

          .inner_right_icon {

          }
        }
      }
    }
  }


  @keyframes leftMove {
    0% {
      left: 30%;
    }
    50% {
      left: 16%;
    }
    100% {
      left: 30%;
    }
  }

  @keyframes rightMove {
    0% {
      right: 30%;
    }
    50% {
      right: 16%;
    }
    100% {
      right: 30%;
    }
  }
</style>
